
import { CloseOutlined } from '@ant-design/icons';
import { useLocalStorageState } from 'ahooks';
import classnames from 'classnames';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import RedWarmingFill from '@/assets/images/icons/red-warming-fill.react.svg?react';
import WarmingFillMax from '@/assets/images/icons/warming-fill.max.react.svg?react';
import { ENV } from '@/infrastructure/env-config';
import { getParamFromUrl } from '@/infrastructure/history';
import { formatNum } from '@/infrastructure/utils/digit';
import styles from '@/presentation/components/arrears-reminder/index.module.scss';
import { useStores } from '@/presentation/store';
import { ProductExceedStatus } from '@/proto/resource-manager';


export const ArrearsReminder = observer(() => {
  const { productExceed = {} } = useStores().ProductStore;
  const { status, exceedQuota } = productExceed;
  const [time, setTime] = useLocalStorageState<number | undefined>(
    'arrears-reminder-time',
    {
      defaultValue: 0,
    },
  );
  const linkParams = new URLSearchParams();
  linkParams.set('appId', getParamFromUrl('productId'));

  const close = () => {
    setTime(moment().unix());
  };

  // 是否超过1天
  const isExceed1Day = useMemo(() => {
    if (!time) {
      return true;
    }
    const storageTime =  moment.unix(time);
    const currentTime = moment();
    return currentTime.diff(storageTime, 'hours') >= 24;
  }, [time]);


  if ((status !== ProductExceedStatus.HAS_ALREADY_EXCEED
    && status !== ProductExceedStatus.WILL_EXCEED) || !isExceed1Day) {
    return null;
  }

  return <div
    className={classnames({
      [styles.arrearsReminder]: true,
      [styles.willExceed]: status === ProductExceedStatus.WILL_EXCEED,
      [styles.hasAlreadyExceed]: status === ProductExceedStatus.HAS_ALREADY_EXCEED,
    })}>
    {status === ProductExceedStatus.WILL_EXCEED && !ENV.isGlobal ? <span className={styles.txt}>
      <WarmingFillMax/>
  尊敬的用户，当前产品资源包剩余上报量少于最近7天用量，请及时<Link
  to={{ pathname: '/resource-pack', search: linkParams.toString() }} target="_blank">购买资源包</Link>，以免影响数据上报、告警通知等服务。
</span> : null}
    {status === ProductExceedStatus.WILL_EXCEED && ENV.isGlobal ? <span className={styles.txt}>
      <WarmingFillMax/>
  尊敬的用户，当前产品资源包剩余上报量少于最近7天用量。
</span> : null}

    {status === ProductExceedStatus.HAS_ALREADY_EXCEED && !ENV.isGlobal ? <span className={styles.txt}>
      <RedWarmingFill/>
  尊敬的用户，当前已经欠费（{formatNum((exceedQuota || 0) as number)}条上报量未正常抵扣），平台已经停止数据上报及告警等服务，请及时<Link
      to={{ pathname: '/resource-pack', search: linkParams.toString() }} target="_blank">购买资源包</Link>，恢复相关服务。
</span> : null}
    {status === ProductExceedStatus.HAS_ALREADY_EXCEED && ENV.isGlobal ? <span className={styles.txt}>
      <RedWarmingFill/>
  尊敬的用户，当前已经欠费（{formatNum((exceedQuota || 0) as number)}条上报量未正常抵扣），平台已经停止数据上报及告警等服务。
</span> : null}
    <CloseOutlined onClick={close} title={'关闭'} className={styles.closeIcon} />
  </div>;
});
